export enum DriversRoute {
  DRIVERS_LIST = '/drivers',
  ADD_DRIVER = '/drivers/add',
  IMPORT_RESULT = '/drivers/import',
  DRIVER_CARD = '/drivers/:uuid',
  EDIT_DRIVER = '/drivers/:uuid/edit',
}
